import { useEffect, useMemo } from "react"
import { useDispatch, useSelector } from "react-redux"
import { getDeliveryProfilesScope } from "store/actions/globalSettingAction"
import { brandSupportsFastMovingItems } from "utils/deliveryProfileHelpers"
import useBrandOptions from "./useBrandOptions"

const useShowFastMovingItemToggle = () => {
  const dispatch = useDispatch()
  const { deliveryProfilesScope } = useSelector(state => state.GlobalSettings)
  const { selectedBrand } = useSelector(state => state.MenuFilterReducer)
  const { allowedBrands, hasOnlyOneBrand } = useBrandOptions()

  useEffect(() => {
    dispatch(getDeliveryProfilesScope())
  }, [dispatch])

  const brandId = useMemo(() => {
    if (selectedBrand?.value) {
      return selectedBrand.value
    }
    if (hasOnlyOneBrand && allowedBrands?.[0]?._id) {
      return allowedBrands[0]._id
    }
    return null
  }, [selectedBrand, hasOnlyOneBrand, allowedBrands])

  return useMemo(
    () =>
      brandSupportsFastMovingItems(
        deliveryProfilesScope?.cards,
        brandId
      ),
    [deliveryProfilesScope, brandId]
  )
}

export default useShowFastMovingItemToggle
